import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store';
Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.VUE_APP_BASE_CONTEXT,
  routes: routes,
  // mode: 'history',
})

// TBD 鉴权加在这
router.beforeEach(async (to, from, next) => {
  if (to.meta.module === 'project') {
    //只有在项目页面才需要加载配置
    await store.dispatch("business/loadConfig", to.params.id);
  }else{
    //非项目页面，直接加载完成
    store.commit("business/setConfigLoaded", true);
  }
  next();
})
export default router
